import styled from 'styled-components';
import { Drawer as DrawerBase } from '@mui/material';
import { ReactComponent as CloseIcon } from '../../assets/close-2.svg';
import { HEADER_HEIGHT } from '../../constants';
import { FlexColumn, FlexSpace } from '../Flex';
import { componentToken } from '../../style/utils';

export const DrawerStyled = styled(DrawerBase).attrs({
  anchor: 'right',
  hideBackdrop: true,
  ModalProps: {
    disableEnforceFocus: true,
    disableAutoFocus: true,
    disableRestoreFocus: true,
    sx: {
      pointerEvents: 'none',
      '& .MuiDialog-container': {
        pointerEvents: 'none',
      },
      '> .MuiPaper-root': {
        height: `calc(100% - ${HEADER_HEIGHT}px)`,
        marginTop: `${HEADER_HEIGHT}px`,
        pointerEvents: 'auto',
      },
    },
  },
  PaperProps: { elevation: 0, style: { backgroundColor: 'transparent' } },
})<{ $rightOffset?: number }>`
  &.MuiDrawer-root {
    z-index: ${({ theme }) => theme.zIndex.drawer + 1};
  }

  > .MuiPaper-root {
    box-shadow: ${componentToken('drawer.paper.shadow')};
    ${({ $rightOffset }) =>
      $rightOffset && `clip-path: inset(-8px 0 -8px -8px);`}
    border-radius: ${componentToken('drawer.paper.radius')};
    right: ${({ $rightOffset }) => $rightOffset || 0}px;
  }
`;

export const Wrapper = styled(FlexColumn)<{
  $width: number;
  $rightOffset?: number;
}>`
  background-color: ${componentToken('drawer.wrapper.backgroundColor')};
  height: 100%;
  width: ${({ $width }) => $width}px;
  border-radius: ${componentToken('drawer.wrapper.borderRadius')};
  border: 1px solid ${componentToken('drawer.wrapper.border')};
  border-top: none;
  border-right: ${({ $rightOffset }) => ($rightOffset ? 'none' : undefined)};
  overflow: hidden;
`;

export const Header = styled(FlexSpace)`
  padding: ${componentToken('drawer.header.padding')};
  border-bottom: 1px solid ${componentToken('drawer.header.borderBottom')};
  height: 57px;
`;

export const Footer = styled(FlexSpace)`
  justify-content: flex-end;
  padding: ${componentToken('drawer.footer.padding')};
  border-top: 1px solid ${componentToken('drawer.footer.borderTop')};
`;

export const Content = styled(FlexColumn)<{ $noPadding?: boolean }>`
  height: 100%;
  padding: ${({ $noPadding }) =>
    $noPadding ? 0 : componentToken('drawer.content.padding')};
  overflow: auto;
`;

export const CloseIconStyled = styled(CloseIcon)`
  width: 14px;
  height: 14px;
  path {
    fill: ${componentToken('drawer.closeIcon.fill')};
  }
`;
